import React, {useState, useMemo, memo, useContext} from "react";
import {useTranslation} from "react-i18next";
//local
import {RichEditor} from "components/RichEditor";
import {TitleIcon} from "components/TitleIcon";
import {signContractPartySide, signContractSide} from "../constants";
import {IconMailLetter, IconLibrary} from "components/icons";
import {SignContractSigningParty} from "./SignContractSigningParty";
import SignContractFileData from "./SignContractFileData";
import SignContractFiles from "./SignContractFiles";
import {SignContractContext} from "../SignContractContext";

const SignContractData = memo(
  ({
    contract,
    isOwner,
    isSignOrderUsed,
    fileDataView,
    onChangeFileDataView,
    onChange,
  }) => {
    const {t} = useTranslation();
    const {status, side} = useContext(SignContractContext);

    const isBuyerSide = useMemo(() => side === signContractSide.BUYER, [side]);

    const messagePlaceholder = useMemo(
      () => `SIGN_CONTRACT_DATA_MESSAGE_${isBuyerSide ? "DESCRIPTION" : "EMPTY"}`,
      [isBuyerSide]
    );

    const onChangeMessage = (message) => onChange("message", message);

    return (
      <div className="signing_contract__data">
        {fileDataView ? (
          <SignContractFileData
            contract={contract}
            onBack={() => {
              onChangeFileDataView(false);
              onChange(undefined, undefined, "refresh");
            }}
            onChange={onChange}
          />
        ) : (
          <React.Fragment>
            <SignContractFiles
              contract={contract}
              columnTitles={{
                contracts: "SIGN_CONTRACT_DATA_FILES_CONTRACTS_COLUMN_TITLE",
                documents: "SIGN_CONTRACT_DATA_FILES_DOCUMENTS_COLUMN_TITLE",
                plans: "SIGN_CONTRACT_DATA_FILES_PLANS_COLUMN_TITLE",
              }}
              columnAddPermissions={{
                contracts: ["ENABLE_SIGN_CONTRACT_FILES_ADD_CONTRACTS"],
                documents: ["ENABLE_SIGN_CONTRACT_FILES_ADD_DOCUMENTS"],
                plans: ["ENABLE_SIGN_CONTRACT_FILES_ADD_PLANS"],
              }}
              onChange={onChange}
              onCreateManualFile={onChangeFileDataView}
            />
            <TitleIcon
              title={t("SIGN_CONTRACT_DATA_SIGNING_PARTIES_TITLE")}
              icon={<IconLibrary addClass="mr-2" />}
              addClass="mt-4"
              medium
            />
            <SignContractSigningParty
              key={`${contract.id}_${signContractPartySide.OWN}`}
              contract={contract}
              onChange={onChange}
              isOwner={isOwner}
              isSignOrderUsed={isSignOrderUsed}
              partySide={signContractPartySide.OWN}
            />
            <SignContractSigningParty
              key={`${contract.id}_${signContractPartySide.THEIR}`}
              contract={contract}
              onChange={onChange}
              isSignOrderUsed={isSignOrderUsed}
              partySide={signContractPartySide.THEIR}
              addClass="mt-4"
            />
            <TitleIcon
              title={t("SIGN_CONTRACT_DATA_MESSAGE_TITLE")}
              icon={<IconMailLetter width="19" height="12" addClass="mr-2" />}
              addClass="mt-8"
              medium
            />
            <RichEditor
              key={contract?.id}
              initialValue={contract?.message}
              mode={status.isDraft ? "edit" : "view"}
              placeholder={messagePlaceholder}
              showExtendedToolbarButtons
              onChange={onChangeMessage}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
);

export default SignContractData;
